import React, { PureComponent } from 'react'
import {
  func, shape, string, bool,
} from 'prop-types'
import Form from '@active/react-ui/Form'
import FormField from '@active/react-ui/FormField'
import FormStaticField from '@active/react-ui/FormStaticField'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import Button from '@active/react-ui/Button'
import EmailInput from '@active/react-ui/EmailInput'
import { withI18n } from '@active/react-utils/i18n'

import { isTrue } from '../../../shared/utils/commonUtils'
import SentEmailNotice from './components/SentEmailNotice'
import I18nMessage from '../I18nMessage'
import DefaultComponentLayout, { LayoutContent } from '../Layout'
import TextHr from '../TextHr'

import './SendEmail.scss'

class SendEmail extends PureComponent {
  static propTypes = {
    title: string.isRequired,
    subTitle: string.isRequired,
    goBack: func,
    sentEmailGoBack: func,
    actions: shape({
      forgotPwdSuccessCallback: func,
    }),
    services: shape({
      sendResetPasswordEmail: func.isRequired,
    }).isRequired,
    configureTrack: func.isRequired,
    Header: func,
    fields: shape({
      email: string,
    }),
    usernameReadonly: string,
    countToClose: bool,
    redirectCustomizedUrl: string,
    showNoticeOnly: bool,
    sentEmail: string,
  }

  static defaultProps = {
    fields: {},
    goBack: undefined,
    sentEmailGoBack: undefined,
    Header: null,
    actions: {
      forgotPwdSuccessCallback: undefined,
    },
    usernameReadonly: '',
    countToClose: false,
    redirectCustomizedUrl: undefined,
    showNoticeOnly: false,
    sentEmail: '',
  }

  constructor(props) {
    super(props)
    this.state = {}
  }

  handleSubmit = ({ email }) => {
    const {
      services, configureTrack, countToClose,
      actions: {
        forgotPwdSuccessCallback,
      },
      redirectCustomizedUrl,
    } = this.props
    if (email) {
      Promise.resolve(email)
        .then(() => services.sendResetPasswordEmail({
          params: { email, countToClose, redirectCustomizedUrl },
          resolve: ({ succeed, data }) => {
            if (succeed === 'true') {
              configureTrack({
                eventName: 'ForgetPasswordMailSent',
                widget: 'forget_password',
                pageType: 'forget password',
                explicitName: 'forget password email sent',
              })
              forgotPwdSuccessCallback && forgotPwdSuccessCallback({ email })
              this.setState({ email })
            } else {
              configureTrack({
                eventName: 'ForgetPasswordError',
                widget: 'forget_password',
                pageType: 'forget password',
                explicitName: 'forget password error',
              })
              throw new Error(data)
            }
          },
          reject: ({ message }) => {
            throw new Error(message)
          },
        }))
        .catch(({ message }) => {
          this.setState({
            errorMsg: message,
          })
        })
    }
  }

  handleChange = () => {
    this.setState({
      errorMsg: null,
    })
  }

  render() {
    const {
      title,
      subTitle,
      Header,
      goBack,
      sentEmailGoBack,
      fields,
      usernameReadonly,
      countToClose,
      showNoticeOnly,
      sentEmail,
      ...rest
    } = this.props
    const { email, errorMsg } = this.state
    return (
      <div>
        {email || showNoticeOnly
          ? (
            <SentEmailNotice
              email={showNoticeOnly ? sentEmail : email}
              Header={Header}
              {...rest}
              goBack={sentEmailGoBack}
              countToClose={countToClose}
            />
          )
          : (
            <DefaultComponentLayout nameSpace="passport__forgotpassword" Header={Header} errMsg={errorMsg}>
              <LayoutContent title message={title} />
              <LayoutContent subTitle message={subTitle} />
              <LayoutContent main>
                <Form
                  onSubmit={this.handleSubmit}
                  onChange={this.handleChange}
                  initialValues={fields}
                >
                  <FormGroup name="email" required withoutLayout hideAsterisk>
                    <FormLabel>
                      <I18nMessage id="passport.common.label.emailAddress" />
                    </FormLabel>
                    {isTrue(usernameReadonly) && fields.email ? (
                      <FormStaticField
                        value={fields.email}
                      />
                    ) : (
                      <FormField
                        as={EmailInput}
                        autoComplete="email"
                        requiredError="passport.error.validation.invalidEmail"
                        invalidError="passport.error.validation.invalidEmail"
                      />
                    )}
                  </FormGroup>
                  <Button className="passport__forgotpassword__button" submit type="super">
                    <I18nMessage id="passport.forgotPwd.btn.sendPasswordLink" />
                  </Button>
                  {
                  goBack
                  && (
                  <Button className="passport__forgotpassword__button" type="secondary" onClick={goBack}>
                    <I18nMessage id="passport.common.btn.back" />
                  </Button>
                  )
                }
                  <TextHr id="passport.forgotPwd.text.needHelp" className="active-branded" />
                  <div className="passport__content text-font-12 active-branded">
                    <I18nMessage id="passport.forgotPwd.notice.existingAcctMsg" />
                  </div>
                </Form>
              </LayoutContent>
            </DefaultComponentLayout>
          )}
      </div>
    )
  }
}

export default withI18n(SendEmail)
